module.exports = __webpack_public_path__ + "static/media/utensils.8da08877.svg";